import React from 'react'

import PropTypes from 'prop-types'

import Grid from '@material-ui/core/Grid'

import logo from '@galo-monitor/styles/assets/images/galomonitor-logo.svg'
import image from '@galo-monitor/styles/assets/images/login.jpg'
import Copyright from '@galo-monitor/web-components/Copyright'
import ImageBackground from '@galo-monitor/web-components/ImageBackground'

import useStyles from './styles'

const GuestLayout = (props) => {
  const { children } = props

  const classes = useStyles()

  return (
    <div className={ classes.container }>
      <div className={ classes.contentScroll }>
        <Grid container style={ { flex: 1 } }>
          <Grid item xs={ false } sm={ 7 } md={ 8 } lg={ 8 } style={ { flex: 1 } }>
            <ImageBackground
              src={ image }
              size="cover"
            />
          </Grid>
          <Grid item xs={ 12 } sm={ 5 } md={ 4 } lg={ 4 }>
            <div className={ classes.cardContainer }>
              <img
                alt="Galo Monitor"
                src={ logo }
                width={ 70 }
                className={ classes.logo }
              />
              {children}

              <div className={ classes.copyright }>
                <Copyright />
              </div>
            </div>
          </Grid>

        </Grid>
      </div>
    </div>
  )
}

GuestLayout.propTypes = {
  children: PropTypes.element.isRequired
}

export default GuestLayout
